export enum LMS_LeaveRequestStatus {
    Reserved = 0,
    Approved = 1,
    Decline = 2,
    Negotiate = 3,
    RequestPending = 4,
    New = 5,
    Drafted = 6,
    Withdrawn = 7,
}
